import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  UnfoldMore as UnfoldMoreIcon,
} from '@mui/icons-material';

export type WidgetListPaginationProps = {
  page: number;
  pageCount: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onOpenFullView?: () => void;
  fullViewLabel?: string;
  disabled?: boolean;
};

const WidgetListPagination: React.FC<WidgetListPaginationProps> = ({
  page,
  pageCount,
  totalItems,
  pageSize,
  onPageChange,
  onOpenFullView,
  fullViewLabel = '전체보기',
  disabled = false,
}) => {
  if (totalItems === 0) return null;

  const start = page * pageSize + 1;
  const end = Math.min(totalItems, (page + 1) * pageSize);
  const canPrev = page > 0;
  const canNext = page < pageCount - 1;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mt: 1.5,
        pt: 1,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        {totalItems}건 중 {start}–{end} · {page + 1} / {pageCount}페이지
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<ChevronLeftIcon />}
          disabled={disabled || !canPrev}
          onClick={() => onPageChange(page - 1)}
        >
          이전
        </Button>
        <Button
          size="small"
          variant="outlined"
          endIcon={<ChevronRightIcon />}
          disabled={disabled || !canNext}
          onClick={() => onPageChange(page + 1)}
        >
          다음
        </Button>
        {onOpenFullView ? (
          <Button
            size="small"
            variant="text"
            startIcon={<UnfoldMoreIcon />}
            disabled={disabled}
            onClick={onOpenFullView}
          >
            {fullViewLabel}
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

export default WidgetListPagination;
